import React from "react";
import PropTypes from "prop-types";

// Semantic tone classes for each status (bg + text token pair).
const TONE = {
  neutral: "bg-surface-2 text-text-2",
  success: "bg-success-soft text-success",
  warning: "bg-warning-soft text-warning",
  primary: "bg-primary-soft text-primary",
  danger: "bg-danger-soft text-danger",
};

const STATUS_CONFIG = {
  draft: { label: "Draft", tone: "neutral" },
  // Financial-control / board-report verdict vocabulary (financialcontrol.OverallStatus):
  // GET /api/v1/financial-control/summary → overall.status.
  green: { label: "On track", tone: "success" },
  at_risk: { label: "At risk", tone: "warning" },
  over: { label: "Over budget", tone: "danger" },
  active: { label: "Active", tone: "success" },
  pending_approval: { label: "Pending approval", tone: "warning" },
  retired: { label: "Retired", tone: "neutral" },
  paused: { label: "Paused", tone: "primary" },
  archived: { label: "Archived", tone: "neutral" },
  // Phase 3: Period version statuses
  pending: { label: "Pending", tone: "warning" },
  approved: { label: "Approved", tone: "success" },
  rejected: { label: "Rejected", tone: "neutral" },
  superseded: { label: "Superseded", tone: "neutral" },
  not_set: { label: "Not set", tone: "neutral" },
  draft_change: { label: "Draft change", tone: "primary" },
  invited: { label: "Invited", tone: "warning" },
  suspended: { label: "Suspended", tone: "neutral" },
  cancelled: { label: "Cancelled", tone: "neutral" },
  submitted: { label: "Submitted", tone: "warning" },
  queued: { label: "Queued", tone: "neutral" },
};

const StatusPill = ({ status, activeSince }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.draft;

  let label = config.label;
  if (status === "active" && activeSince) {
    label = `Active · ${activeSince}`;
  }

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold select-none ${TONE[config.tone]}`}
      style={{
        transition: "background-color 150ms ease-in, color 150ms ease-in",
      }}
    >
      {label}
    </span>
  );
};

StatusPill.propTypes = {
  status: PropTypes.string,
  activeSince: PropTypes.string,
};

export default StatusPill;
